import { getClientDomain } from "../functions/client-code";

interface ClientCustomCRMFlags {
  hasFormsAccess: boolean;
  hasHelpdeskFullAccess: boolean;
  hasHelpdeskFeatureRequests: boolean;
  hasHelpdeskResolution: boolean;
  hasHelpdeskCategories: boolean;
  hasHelpdeskBackButtonControl: boolean;
  useNeighbourhoodLabel: boolean;
  useContactLabel: boolean;
  hasPropertyBasedFiltering: boolean;
  hasNowFormsAccess: boolean;
  hasCallLogsAccess: boolean;
  hasCancelledReasonModal: boolean;
  isNowFormsClient: boolean;
  // Date filters default to "Last 6 Months" on every screen, and the option is listed in the
  // duration pickers. Takes precedence over hasLast60DaysDefault.
  hasLast6MonthsFilter: boolean;
  hasLast60DaysDefault: boolean;
  // Prefill destination country/city/property on the create-lead form from
  // /dashboard/leads/create/defaults.
  hasLeadCreateDefaults: boolean;
}

const DEFAULT_FLAGS: ClientCustomCRMFlags = {
  hasFormsAccess: true,
  hasHelpdeskFullAccess: false,
  hasHelpdeskFeatureRequests: false,
  hasHelpdeskResolution: false,
  hasHelpdeskCategories: false,
  hasHelpdeskBackButtonControl: false,
  useNeighbourhoodLabel: false,
  useContactLabel: false,
  hasPropertyBasedFiltering: false,
  hasNowFormsAccess: true,
  hasCallLogsAccess: false,
  hasCancelledReasonModal: true,
  isNowFormsClient: false,
  hasLast6MonthsFilter: false,
  hasLast60DaysDefault: false,
  hasLeadCreateDefaults: false,
};

const NOW_STUDENTS_FLAGS: ClientCustomCRMFlags = {
  hasFormsAccess: true,
  hasHelpdeskFullAccess: true,
  hasHelpdeskFeatureRequests: true,
  hasHelpdeskResolution: true,
  hasHelpdeskCategories: true,
  hasHelpdeskBackButtonControl: true,
  useNeighbourhoodLabel: true,
  useContactLabel: true,
  hasPropertyBasedFiltering: true,
  hasNowFormsAccess: true,
  hasCallLogsAccess: true,
  hasCancelledReasonModal: true,
  isNowFormsClient: false,
  hasLast6MonthsFilter: false,
  hasLast60DaysDefault: false,
  hasLeadCreateDefaults: false,
};

const APARTO_FLAGS: ClientCustomCRMFlags = {
  ...DEFAULT_FLAGS,
  hasCancelledReasonModal: true,
  hasLeadCreateDefaults: true,
};

const CLIENT_CUSTOM_CRM_FLAGS: Record<string, ClientCustomCRMFlags> = {
  nowstudents: { ...NOW_STUDENTS_FLAGS, isNowFormsClient: true },
  herestudents: NOW_STUDENTS_FLAGS,
  aparto: APARTO_FLAGS,
  // The UK and US demo suites demo against a wider window than the other tenants.
  ukdemosuite: { ...DEFAULT_FLAGS, hasLast6MonthsFilter: true },
  vfus: { ...DEFAULT_FLAGS, hasLast6MonthsFilter: true },
  btrdemosuite: { ...DEFAULT_FLAGS, hasLast60DaysDefault: true },
};

export const getClientCRMFlags = (
  clientCode?: string
): ClientCustomCRMFlags => {
  const code = clientCode || getClientDomain();
  return CLIENT_CUSTOM_CRM_FLAGS[code] || DEFAULT_FLAGS;
};

export const getClientCRMFlag = (
  flag: keyof ClientCustomCRMFlags,
  clientCode?: string
): boolean => {
  return getClientCRMFlags(clientCode)[flag];
};

export type { ClientCustomCRMFlags };
